(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8984],{

/***/ 88984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ Empty_NoData; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(28677);
;// CONCATENATED MODULE: ./src/components/common/Icons/svg/Empty.js

function Empty() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "149px",
        height: "80px",
        viewBox: "0 0 149 80",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "监控未获取数据"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "Created with Sketch."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "-47.0190124%",
                        y1: "-185.963888%",
                        x2: "68.8688465%",
                        y2: "100%",
                        id: "linearGradient-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                stopOpacity: "0",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "118.999979%",
                        y1: "-110.864112%",
                        x2: "54.5018665%",
                        y2: "55.5871768%",
                        id: "linearGradient-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                stopOpacity: "0",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "50%",
                        y1: "-221.156912%",
                        x2: "50%",
                        y2: "100%",
                        id: "linearGradient-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                stopOpacity: "0",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "100.080959%",
                        y1: "-97.780461%",
                        x2: "38.826306%",
                        y2: "104.736078%",
                        id: "linearGradient-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                stopOpacity: "0",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "50%",
                        y1: "-227.711528%",
                        x2: "50%",
                        y2: "100%",
                        id: "linearGradient-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                stopOpacity: "0",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "50%",
                        y1: "-169.203289%",
                        x2: "50%",
                        y2: "100%",
                        id: "linearGradient-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B6BCC7",
                                stopOpacity: "0",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "67.6673831%",
                        y1: "48.2527144%",
                        x2: "73.0360423%",
                        y2: "53.742435%",
                        id: "linearGradient-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#171E26",
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#171E26",
                                stopOpacity: "0.5",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "0%",
                        y1: "50%",
                        x2: "100%",
                        y2: "50%",
                        id: "linearGradient-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F2F2F2",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#EDEDED",
                                offset: "13%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E0E0E0",
                                offset: "59%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DBDBDB",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "linearGradient-9",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#D2D2D2",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1E1E1",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "0%",
                        y1: "50%",
                        x2: "100%",
                        y2: "50%",
                        id: "linearGradient-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F2F2F2",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#EDEDED",
                                offset: "13%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E0E0E0",
                                offset: "59%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DBDBDB",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "5.0434168e-08%",
                        y1: "23.5102557%",
                        x2: "102.179665%",
                        y2: "70.8893821%",
                        id: "linearGradient-11",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F4F4F4",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#858E9D",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "0%",
                        y1: "50%",
                        x2: "100%",
                        y2: "50%",
                        id: "linearGradient-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F2F2F2",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#EDEDED",
                                offset: "13%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E0E0E0",
                                offset: "59%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DBDBDB",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "5.0434168e-08%",
                        y1: "14.7684782%",
                        x2: "102.179665%",
                        y2: "77.7830058%",
                        id: "linearGradient-13",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F4F4F4",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#858E9D",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "linearGradient-14",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#D2D2D2",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1E1E1",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "linearGradient-15",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#D2D2D2",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1E1E1",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "linearGradient-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#D2D2D2",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1E1E1",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "0%",
                        y1: "50%",
                        x2: "93.4315876%",
                        y2: "43.6375837%",
                        id: "linearGradient-17",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFF6E1",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F3AD00",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "5.68165075%",
                        y1: "83.6958265%",
                        x2: "26.1148874%",
                        y2: "65.2986587%",
                        id: "linearGradient-18",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#D9A524",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#B98A14",
                                offset: "99.9815245%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "5.78306055%",
                        y1: "71.6490318%",
                        x2: "97.2052151%",
                        y2: "25.9835295%",
                        id: "linearGradient-19",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F3AD00",
                                offset: "0.0184755068%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F3AD00",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "25.1176925%",
                        y1: "74.2574387%",
                        x2: "92.1956761%",
                        y2: "1.78677272%",
                        id: "linearGradient-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFF6DF",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F3AD00",
                                offset: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "页面-1",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "07-资产管理-交易记录-持仓记录",
                    transform: "translate(-774.000000, -314.000000)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "编组-23",
                        transform: "translate(774.500000, 314.000000)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            id: "监控未获取数据",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "编组-2备份-6",
                                    fillRule: "nonzero",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M29.3037037,63.8216328 C26.1382716,62.389534 22.7061728,58.5475588 23.6790124,54.9327436 C24.1655944,54.808206 24.6775408,55.0066348 24.9530864,55.4265708 C24.9530864,55.4265708 30.4444444,64.0043488 28.9037037,56.1129908 C28.1777778,52.4043488 26.9283951,48.8191636 26.8296296,44.9870648 C26.6666667,38.0241018 33.0567901,36.0932376 34.8938272,43.7870648 C35.1358025,44.8043488 36.0641975,53.0759536 38.1777778,52.1278056 C38.4500134,51.9846228 38.6709313,51.7602528 38.8098766,51.4858304 C39.8814815,49.7278056 40.2024692,47.1450896 42.1679012,46.5475588 C43.891358,46.0043488 45.5901236,47.5006452 46.5185184,49.046324 C48.4,52.1870648 50.9185184,59.994472 47.0666668,62.6413856 C43.2148148,65.2882992 33.4962963,65.7080524 29.3382716,63.8562004 L29.3037037,63.8216328 Z",
                                            id: "路径",
                                            fill: "url(#linearGradient-1)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M109.274074,72.17225 C107.881482,68.9870648 107.916049,63.8364476 111.076543,61.8018796 C111.523219,62.0419644 111.764464,62.5423972 111.674074,63.0413856 C111.674074,63.0413856 109.990124,73.0907684 114.14321,66.2018796 C116.118518,62.9574352 117.6,59.4660772 120.069136,56.5574352 C124.607408,51.2537316 130.65679,54.1327436 126.859259,61.0710152 C126.365432,61.989534 121.496296,68.7450896 123.698766,69.4660772 C123.996942,69.539406 124.310356,69.5204632 124.597531,69.411756 C126.57284,68.82904 128.548148,67.1302748 130.414815,67.989534 C132.054321,68.7450896 132.311111,70.9870648 131.965432,72.7599044 C131.254321,76.3500276 127.768688,80.364848 123.13659,79.7426256 C118.405726,79.1006504 111.111111,76.3697808 109.288889,72.206818 L109.274074,72.17225 Z",
                                            id: "路径",
                                            fill: "url(#linearGradient-2)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M148.207408,79.7426204 C129.585185,66.9673116 103.269136,59.0018796 74.1037036,59.0018796 C44.9382716,59.0018796 18.6222222,66.9673116 0,79.7426204 L148.207408,79.7426204 Z",
                                            id: "路径",
                                            fill: "url(#linearGradient-3)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M117.387654,41.224102 C116.207408,42.7055832 115.451852,44.8043488 116.158025,46.680892 C116.646914,47.9747192 118.118518,47.9845956 118.014815,49.7821264 C117.913274,50.6796676 117.605682,51.5416 117.116049,52.3006452 C116.2817,53.7600096 115.258928,55.1032284 114.074074,56.2957068 C115.061722,57.0661048 115.564156,58.3043124 115.392592,59.5450896 C115.198892,60.7766464 114.615643,61.9137236 113.728395,62.789534 C113.467152,63.1089936 113.126566,63.3542156 112.740741,63.5006452 C112.367059,63.5869556 111.97862,63.5869556 111.604938,63.5006452 C109.767625,63.1888164 107.983684,62.6185536 106.306173,61.806818 C105.259259,61.3080524 104.192592,60.6265708 103.837037,59.5401512 C103.42963,58.2932376 104.077392,57.8970184 104.784472,57.5063452 L104.966972,57.4054764 C105.33208,57.2018544 105.6903,56.9805392 105.906173,56.6265708 C106.424691,55.7771884 106.439506,54.6413856 106.622222,53.6932376 C106.888889,52.2957068 106.493827,49.7475588 108.241975,49.1994104 C108.918518,48.9870648 109.654321,49.0364476 110.330864,48.8191636 C111.800549,48.3513996 112.408977,46.9688968 112.998042,45.5710256 L113.105118,45.316898 C113.444705,44.5128924 113.794787,43.7218612 114.316049,43.11546 C115.05679,42.2512624 116.893827,41.8265708 117.387654,41.224102 Z M113.120988,49.51546 C113.120988,49.51546 107.802469,55.7179288 107.975309,61.4512624 L109.693827,61.4512624 C109.693827,61.4512624 110.316049,54.537682 113.120988,49.51546 Z",
                                            id: "形状结合",
                                            fill: "url(#linearGradient-4)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M41.6543208,8.80434872 L41.6543208,8.80434872 C41.6817924,6.890083 40.3144888,5.23947452 38.4285543,4.91020388 C36.5426198,4.58093324 34.6968893,5.67056904 34.0740741,7.48089192 C32.8858386,7.45759996 31.7796804,8.08487032 31.1896861,9.11654504 C30.5996918,10.1482198 30.6199966,11.419692 31.2426326,12.4320015 C31.8652685,13.444311 32.990892,14.0359408 34.1777778,13.9747191 L41.3333332,13.9747191 C42.6919464,13.9565968 43.8070372,12.8944928 43.891228,11.5383697 C43.9754192,10.1822465 43.00026,8.9903754 41.6543208,8.80434872 L41.6543208,8.80434872 Z",
                                            id: "路径",
                                            fill: "url(#linearGradient-5)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M71.2296296,4.88336108 L71.2296296,4.85866972 C71.2267196,2.49261942 69.5217012,0.471861752 67.1898824,0.0708328216 C64.858064,-0.330196107 62.5759116,1.00484323 61.782716,3.23397836 C59.5394852,3.26943368 57.74973,5.11667364 57.7851852,7.35990428 C57.8206404,9.60313492 59.6678804,11.3928905 61.9111112,11.3574352 L70.8,11.3574352 C72.5125904,11.3604871 73.9316868,10.0300116 74.0389224,8.320779 C74.146158,6.6115464 72.9044808,5.11413636 71.2049384,4.90311416 L71.2296296,4.88336108 Z",
                                            id: "路径",
                                            fill: "url(#linearGradient-6)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    id: "编组-38",
                                    transform: "translate(27.400000, 6.000000)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "矩形",
                                            fill: "url(#linearGradient-7)",
                                            fillRule: "nonzero",
                                            points: "-1.81188398e-13 50.4 21.1349948 50.4 42.4 62 21.51168 61.467906"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "路径",
                                            fill: "url(#linearGradient-8)",
                                            fillRule: "nonzero",
                                            points: "45.239506 24.1777778 45.0320988 37.3925924 75.2592592 28.2419753"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "路径",
                                            fill: "url(#linearGradient-9)",
                                            fillRule: "nonzero",
                                            points: "21.160494 29.4962963 45.239506 24.2320988 45.239506 32.2567901"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "路径",
                                            fill: "url(#linearGradient-10)",
                                            fillRule: "nonzero",
                                            points: "21.160494 29.4962963 49.5802468 32.3111111 49.5802468 68.2716048 21.160494 61.3925924"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "矩形",
                                            fill: "url(#linearGradient-11)",
                                            fillRule: "nonzero",
                                            opacity: "0.304617746",
                                            points: "21.160494 29.4962963 49.6 32.2 46.503624 49.5614544 21.160494 44.281876"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "路径",
                                            fill: "url(#linearGradient-12)",
                                            fillRule: "nonzero",
                                            opacity: "0.99",
                                            points: "49.5802468 32.3111111 75.2592592 28.2419753 75.2592592 60.4543208 49.5802468 68.2716048"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "矩形",
                                            fill: "url(#linearGradient-13)",
                                            fillRule: "nonzero",
                                            points: "49.6 32.4 72.8463436 28.6833305 75.2592592 43.8904028 53.0362324 49.5614544"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "路径",
                                            fill: "url(#linearGradient-14)",
                                            fillRule: "nonzero",
                                            points: "21.160494 29.4962963 14.3259259 41.0666668 43.017284 46.5382716 49.5802468 32.3111111"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            id: "路径",
                                            fill: "url(#linearGradient-15)",
                                            fillRule: "nonzero",
                                            opacity: "0.99",
                                            points: "49.5802468 32.3111111 57.6493828 46.5382716 83.5111112 40.0493828 75.2592592 28.2419753"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M46.074074,31.2296296 C46.2370372,31.2296296 46.4,31.2691358 46.5679012,31.2790124",
                                            id: "路径",
                                            stroke: "#DDDDDD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                            x1: "63.8765432",
                                            y1: "19.3777778",
                                            x2: "64.0592592",
                                            y2: "18.9185185",
                                            id: "路径",
                                            stroke: "#DDDDDD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M60,14.8 C52.6989916,19.5865878 48.230966,23.8441968 49.5592456,26.4805898 C51.3646448,30.0639781 54.430624,28.5763581 54.895884,27.0728332 C55.3611436,25.5693083 54.0807484,22.6344012 51.3646448,24.2320988 C48.6485416,25.8297963 45.6890024,28.6949924 45.0320988,31.5012346",
                                            id: "路径-19",
                                            stroke: "url(#linearGradient-16)",
                                            strokeWidth: "2",
                                            strokeDasharray: "4,3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            id: "飞机",
                                            transform: "translate(55.940844, 0.000000)",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                    id: "路径-16备份",
                                                    fill: "url(#linearGradient-17)",
                                                    fillRule: "nonzero",
                                                    points: "23.6 1.41398004e-13 0 4.47099852 6 8.45355508"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                    id: "路径-16备份-2",
                                                    fill: "url(#linearGradient-18)",
                                                    fillRule: "nonzero",
                                                    points: "23.6 0 6 8.45355508 6 15.2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                    id: "路径-16备份-2",
                                                    fill: "url(#linearGradient-19)",
                                                    fillRule: "nonzero",
                                                    points: "23.6 1.3500312e-14 6 8.45355508 9.47877196 12.197821"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                    id: "路径-16备份",
                                                    fill: "url(#linearGradient-20)",
                                                    fillRule: "nonzero",
                                                    points: "23.6 0 8.52825228 10.1535106 15.7689997 14.8"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                    x1: "6",
                                                    y1: "8.45355508",
                                                    x2: "0.0726036092",
                                                    y2: "4.65402132",
                                                    id: "路径-16",
                                                    stroke: "#FFE9AB",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                    x1: "8.64366276",
                                                    y1: "10.298042",
                                                    x2: "15.5804279",
                                                    y2: "14.7434138",
                                                    id: "路径-17",
                                                    stroke: "#FFE9AB",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                                    x1: "6",
                                                    y1: "8.45355508",
                                                    x2: "6",
                                                    y2: "14.9981979",
                                                    id: "路径-18",
                                                    stroke: "#FFE9AB",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var svg_Empty = (Empty);

// EXTERNAL MODULE: ./src/components/common/Empty/NoData.module.scss
var NoData_module = __webpack_require__(78198);
var NoData_module_default = /*#__PURE__*/__webpack_require__.n(NoData_module);
;// CONCATENATED MODULE: ./src/components/common/Empty/NoData.js




function NoData() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NoData_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_Empty, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("noData")
            })
        ]
    });
}
/* harmony default export */ var Empty_NoData = (NoData);

;// CONCATENATED MODULE: ./src/components/common/Empty/index.js
/* eslint-disable import/prefer-default-export */ 


/***/ }),

/***/ 78198:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NoData_container__1mN0W"};

/***/ })

}]);